/**
 * Configuration for the Aggregates API V3 Get
 */
export default {
	id: 'aggregatesV3Get',
	name: 'Aggregates (GET)',
	resultsTitle: 'Recommendations',
	version: 'v3',
	fields: [
		{
			name: 'Aggregate Id',
			placeholder: 'Enter Aggregate Id',
			required: true,
			value: '',
			id: 'id',
			type: 'text',
		},
		{
			name: 'Order By',
			required: false,
			value: 'Relevance',
			id: 'orderBy',
			type: 'select',
			options: [
				{
					value: 'Relevance',
					name: 'Relevance',
				},
				{
					value: 'PublishedDate',
					name: 'Most recent first',
				},
				{
					value: 'Popularity',
					name: 'Most popular published articles first',
				},
				{
					value: 'Popularity7Days',
					name: 'Popularity 7 Days',
				},
				{
					value: 'Popularity30Days',
					name: 'Popularity 30 Days',
				},
				{
					value: 'LastUpdatedDate',
					name: 'Most recently updated first',
				},
				{
					value: 'LastOptimizedDate',
					name: 'Last Optimized Date',
				},
				{
					value: 'AverageRating',
					name: 'Average Rating',
				},
				{
					value: 'ReviewsCount',
					name: 'Ordered by reviews count from high to low',
				},
				{
					value: 'UgcRelevance',
					name: 'Ugc Relevance',
				},
				{
					value: 'AverageRating',
					name: 'Content ordered by average rating from high to low',
				},
				{
					value: 'AverageRating',
					name: 'Content ordered by average rating from high to low',
				},
			],
		},
		{
			name: 'Exclude Affiliate Content',
			placeholder: '',
			required: false,
			value: false,
			id: 'excludeAffiliateContent',
			type: 'bool',
		},
		{
			name: 'Sources',
			placeholder: 'Enter sources...',
			required: false,
			value: null,
			id: 'sourceFilter',
			type: 'csv',
			autoComplete: '/api/autocomplete/brands',
		},
		{
			name: 'Content-types',
			placeholder: 'Enter content types...',
			required: false,
			value: null,
			id: 'docTypeFilter',
			type: 'csv',
			autoComplete: '/api/autocomplete/types',
		},
		{
			name: 'Variants',
			placeholder: 'Enter variants...',
			required: false,
			value: null,
			id: 'variantFilter',
			type: 'csv',
			autoComplete: '/api/autocomplete/variants',
		},
		{
			name: 'Exclude Ids',
			placeholder: 'Enter excluded ids...',
			required: false,
			value: null,
			id: 'excludeIds',
			type: 'csv',
		},
		{
			name: 'Meredith User Id',
			placeholder: 'Enter User Id',
			required: false,
			value: '',
			id: 'muid',
			type: 'text',
		},
		{
			name: 'Syndicated',
			required: false,
			id: 'syndicated',
			type: 'select',
			options: [
				{
					value: 'All',
					name: 'All',
				},
				{
					value: 'BrandExclusive',
					name: 'Brand Exclusive',
				},
				{
					value: 'DoNotSyndicate',
					name: 'Do Not Syndicate',
				},
				{
					value: 'Branded',
					name: 'Branded',
				},
				{
					value: 'Native',
					name: 'Native',
				},
				{
					value: 'ExternalOnly',
					name: 'External Only',
				},
				{
					value: 'None',
					name: 'None',
				},
				{
					value: 'ContentLicensing',
					name: 'Content Licensing',
				},
			],
		},
		{
			name: 'Start Date',
			placeholder: 'Click to select a start date',
			required: false,
			value: null,
			id: 'startDate',
			type: 'datetime',
		},
		{
			name: 'End Date',
			placeholder: 'Click to select an end date',
			required: false,
			value: null,
			id: 'endDate',
			type: 'datetime',
		},
		{
			name: 'Facets',
			placeholder: '',
			required: false,
			value: null,
			id: 'facets',
			type: 'facets',
		},
		{
			name: 'Range',
			placeholder: '',
			required: false,
			value: null,
			id: 'rangeFilter',
			type: 'range',
		},
		{
			name: 'Page',
			placeholder: 'Page',
			required: false,
			value: 1,
			id: 'page',
			type: 'page',
		},
		{
			name: 'Page Size',
			placeholder: 'Size',
			required: false,
			value: 20,
			id: 'pageSize',
			type: 'pageSize',
		},
	],
};
